import React from "react";
import { Box, Typography } from "@mui/material";
import moment from "moment";
import { getStatusDisplayText } from "./designUtils";
import { changeTypePillSx, getTypeStyle } from "../../changeRequestTypeStyles";

const STATUS_DOT = {
  AWAITING_CONTRACTOR_CONFIRMATION: "#fa8c16",
  default: "#0d0d0e",
};

export default function DesignMetaRow({ changeRequest }) {
  const dotColor =
    STATUS_DOT[changeRequest?.status] ?? STATUS_DOT.default;

  const colSx = {
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  };

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)", md: "repeat(4, minmax(0, 1fr))" },
        gap: { xs: 2, md: 3 },
        mb: 3,
        width: "100%",
        alignItems: "flex-start",
      }}
    >
      <Box sx={colSx}>
        <Typography sx={{ fontSize: "12px", color: "#949DAA", fontWeight: 500, mb: 0.5 }}>
          Change Type
        </Typography>
        <Typography component="span" sx={changeTypePillSx("DESIGN")}>
          {getTypeStyle("DESIGN").text}
        </Typography>
      </Box>
      <Box sx={colSx}>
        <Typography sx={{ fontSize: "12px", color: "#949DAA", fontWeight: 500, mb: 0.5 }}>
          Originator
        </Typography>
        <Typography sx={{ fontSize: "14px", color: "#0d0d0e", fontWeight: 700 }}>
          {changeRequest?.source || changeRequest?.user?.username || "—"}
        </Typography>
      </Box>
      <Box sx={colSx}>
        <Typography sx={{ fontSize: "12px", color: "#949DAA", fontWeight: 500, mb: 0.5 }}>
          Status
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <Box
            sx={{
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              backgroundColor: dotColor,
              flexShrink: 0,
            }}
          />
          <Typography sx={{ fontSize: "14px", color: "#0d0d0e", fontWeight: 500 }}>
            {getStatusDisplayText(changeRequest?.status) || "—"}
          </Typography>
        </Box>
      </Box>
      <Box sx={colSx}>
        <Typography sx={{ fontSize: "12px", color: "#949DAA", fontWeight: 500, mb: 0.5 }}>
          Created on
        </Typography>
        <Typography sx={{ fontSize: "14px", color: "#0d0d0e", fontWeight: 600 }}>
          {changeRequest?.createdAt
            ? moment(changeRequest.createdAt).format("DD MMM YYYY, h:mm A")
            : "—"}
        </Typography>
      </Box>
    </Box>
  );
}
